import axios, { Axios } from 'axios'

export const getApiClient = (apiKey?: string, token?: string): Axios => {
  return axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}`,
    headers: {
      ...(token && { authorization: `Bearer ${token}` }),
      ...(apiKey && { 'api-key': apiKey })
    }
  })
}
